import { BodySecondary } from '@liveauctioneers/hammer-ui-core/text';
import { Fire } from '@liveauctioneers/hammer-ui-core/icons';
import { getItemSummaryCatalogId } from '@/redux/modules/item/summary/itemSummary.selectors';
import { getSavedItemCount } from '@/redux/modules/savedItemCount';
import { useAppSelector } from '@/redux/hooks';
import ButtonGroup from '@/pages/BiddingConsole/components/ButtonGroup/ButtonGroup';
import CurrentBid from '@/pages/BiddingConsole/components/CurrentBid/CurrentBid';
import Estimate from '@/pages/BiddingConsole/components/Estimate/Estimate';
import styled from 'styled-components';

type Props = {
    className?: string;
    itemId: number;
    selectedCurrency: string;
};

const DesktopBidContainer = ({ className, itemId, selectedCurrency }: Props) => {
    const catalogId = useAppSelector((state) => getItemSummaryCatalogId(state, itemId));
    const { savedCount } = useAppSelector((state) => getSavedItemCount(state, itemId));

    return (
        <StyledDesktopBidContainer className={className}>
            <StyledTopRow>
                <div>
                    {Boolean(savedCount) && savedCount !== 0 && (
                        <div className="flex items-center gap-2xs">
                            <Fire
                                color="critical"
                                data-testid="fire-icon"
                                size="sm"
                                style="fill"
                            />
                            <BodySecondary>{savedCount}</BodySecondary>
                        </div>
                    )}
                </div>
                <Estimate itemId={itemId} />
            </StyledTopRow>
            <StyledCurrentBid
                itemId={itemId}
                selectedCurrency={selectedCurrency}
            />
            <StyledButtonGroup
                biddingLocked={false}
                catalogId={catalogId}
            />
        </StyledDesktopBidContainer>
    );
};

export default DesktopBidContainer;

const StyledDesktopBidContainer = styled.section`
    margin: 0 24px 16px;
    padding: 32px;
    background-color: ${({ theme }) => theme.colors.beige100};
    border: 1px solid ${({ theme }) => theme.colors.grey400};
`;

const StyledTopRow = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 8px;
`;

const StyledCurrentBid = styled(CurrentBid)`
    margin-bottom: 16px;
`;

const StyledButtonGroup = styled(ButtonGroup)`
    margin-bottom: 16px;
`;
